import React, { useEffect, useState } from 'react';
import { useCadastroPecasEquip } from '../../hook/cadastroArvore';
import {
  Dialog,
  IconButton,
  Typography,
  DialogBody,
  DialogHeader,
  DialogFooter,
} from '@material-tailwind/react';

import { XMarkIcon } from '@heroicons/react/24/outline';
import { useForm } from 'react-hook-form';
import ButtonGlobal from '../ButtonGlobal';
import MsgSucess from '../MsgSucess';
import ButtonDinamic from '../ButtonDinamic';
import ProdutoCod from '../autoComplet/ProdutoCod';
import MsgInputError from '../MsgInputError';

export function AddModalPecas({ modal, handleModal, item }) {
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    setValue,
    watch,
    formState: { errors },
  } = useForm();
  const { result, patch, resetInfo: resetResult } = useCadastroPecasEquip();
  const watchQtd = watch('quantidade');
  const [winthor, setWinthor] = useState(null);
  const [inputValue, setInputValue] = React.useState('');
  const [formRequired, setFomrRequired] = useState(false);

  useEffect(() => {
    setValue('produtoWinthor', winthor);
    setFomrRequired(false);
  }, [winthor]);

  const onSubmit = (data) => {
    if (!winthor) {
      setFomrRequired(true);
      return;
    }
    const produtoWinthor = data.produtoWinthor.winthor;
    const quantidade = data.quantidade;
    const newData = { produtoWinthor, quantidade, equipamento: item.id };
    patch(newData);
  };

  const resetInfo = () => {
    setInputValue('');
    setWinthor(null);
    reset();
    clearErrors();
    resetResult();
  };

  const oncloseModal = () => {
    handleModal();
    resetInfo();
  };

  return (
    <>
      <Dialog
        size="sm"
        open={modal}
        handler={oncloseModal}
        className={`p-4 bg-lightMenu dark:bg-none dark:bg-darkColorBg`}
      >
        <DialogHeader className="relative m-0 block">
          <Typography variant="h4" color="black" className="dark:text-darkText">
            Adicionar peça a {item.nome}
          </Typography>
          <IconButton
            size="sm"
            variant="text"
            color="white"
            className="!absolute right-3.5 top-3.5"
            onClick={oncloseModal}
          >
            <XMarkIcon className="h-4 w-4 stroke-2" />
          </IconButton>
        </DialogHeader>
        <DialogBody className="space-y-4 pb-6">
          <form className="flex flex-col gap-5">
            <div>
              <Typography
                variant="h6"
                className="mb-1 text-left font-medium text-black dark:text-white capitalize"
              >
                Produto *
              </Typography>
              <ProdutoCod
                register={register}
                value={winthor}
                setValue={setWinthor}
                inputValue={inputValue}
                setInputValue={setInputValue}
              />
              {formRequired && <MsgInputError text="Este campo é obrigatório" />}
            </div>
            <div>
              <ButtonDinamic
                placeholder={'Digite quantidade utilizada'}
                formCamp="quantidade"
                patch
                type="number"
                label="Quantidade"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.quantidade ? errors : false}
                valor={watchQtd}
                cssDiv="w-full"
              />
            </div>
          </form>
        </DialogBody>
        <DialogFooter>
          <ButtonGlobal
            className="ml-auto"
            click={handleSubmit(onSubmit)}
            color="blue"
            text={'Adicionar'}
          />
        </DialogFooter>
        {result?.sucess && (
          <MsgSucess reset={resetInfo} outText="Item adicionado com sucesso" text={winthor.nome} />
        )}
      </Dialog>
    </>
  );
}
